import { render } from "./ViewTabs.vue?vue&type=template&id=ee1a64a2&scoped=true&ts=true"
import script from "./ViewTabs.vue?vue&type=script&lang=ts"
export * from "./ViewTabs.vue?vue&type=script&lang=ts"

import "./ViewTabs.vue?vue&type=style&index=0&id=ee1a64a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee1a64a2"]])

export default __exports__